export const transactionCostLineDefaultValues = {
  amount: "",
  comment: "",
  posting_cost_centre: null,
  posting_entity: null,
  posting_gl_code: null,
  posting_internal_order: null,
  attachments: [],
  cost_type: null,
  private_cost: false,
  vat: null,
  currency_code: null,
  // splitted_cost_id: "null",
  sap_vendor_number: "",
  invoice_number: "",
  is_job_related: false,
};
